import FilterableMultiSelector from '../../../../../../components/selector/FilterableMultiSelector';
import { usePrepareData } from './SearchLicenseUserActionHooks';
import './SearchLicenseUserAction.scss';

const SearchLicenseUserAction = ({ onFilterChange, filterValue, isMultiple, className, popperClassName, disabled } = {
  onFilterChange: () => { },
  filterValue: null,
  isMultiple: false,
  className: '',
  popperClassName: '',
  disabled: false,
}) => {
  const { transformUser, loading } = usePrepareData();

  const handleMultiSelectorApply = (value) => {
    if (value && filterValue && value.key === filterValue) {
      return;
    }
    onFilterChange(value);
  };

  return (
    <FilterableMultiSelector
      popperClassName={popperClassName}
      className={`search-user-action ${className}`}
      key='filter-selector-user'
      onApply={(value) => {
        handleMultiSelectorApply(value);
      }}
      label='Please select user'
      initFilterKeyValues={Array.isArray(filterValue) ? filterValue : filterValue && [filterValue]}
      options={transformUser}
      filterable
      isMultiple={isMultiple}
      subTitle='Filter User'
      disabled={disabled || transformUser.length <= 1}
      loading={loading}
    />
  );
};

export default SearchLicenseUserAction;
